export default "__VITE_ASSET__Dfp3SL8J__"